import styled, { css } from "styled-components";
import { memo } from "react";
import StyledTableCell from "@/react/components/styled/table/StyledTableCell";
import { ListItem } from "@8x8/oxygen-list";
import { color } from "@8x8/oxygen-constants";
import Select from "@8x8/oxygen-select";
import Input from "@8x8/oxygen-input";

/**
  TablePagination related styles
*/

export const MarginLeftSelect = styled(Select)`
  margin-left: 16px;
`;

export const HorizontalMarginInput = styled(Input)`
  margin-left: 16px;
  margin-right: 16px;
  width: 60px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 8px;
`;

export const MarginLeftSpan = styled.span`
  margin-left: 16px;
`;

export const PageSelectWrapper = styled.div`
  width: 140px;
`;

/**
  TableHeadCell related styles
*/
export const TableCell = memo(styled(StyledTableCell)`
  position: relative;

  .sort-btn {
    display: none;
  }

  &:hover {
    .sort-btn {
      display: block;
    }
  }
`);

export const CursorPointerListItem = styled(ListItem)`
  cursor: pointer;
`;

export const HeaderContainer = styled.span`
  ${({ canResize }) =>
    canResize &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: auto;
    `};

  ${({ isCustomTooltip }) =>
    isCustomTooltip &&
    css`
      border-bottom: 1px dotted;
      cursor: help;
    `};
`;

export const SortButtonWrapper = styled.div`
  color: ${color.cloudyBlue900};
  cursor: pointer;
`;

export const ColumnSetterWrapper = styled.div`
  padding: 16px 24px;
`;

/**
  TablePartialDataIndicator related styles
 */

export const PartialDataContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
`;

export const PartialDataInnerContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const CenteredText = styled.div`
  text-align: center;
`;
